<template>
    <div class="login_main">
        <div class="header">
            <!-- <img src="../../assets/img/shop_logo.png" class="logo" /> -->
        </div>

        <div class="main">
            <div class="content">
                <img :src="require('../../assets/img/login_img.png')" class="img" />

                <div class="form">
                    <div class="tab">
                        <div class="item on">密码登录</div>
                    </div>
                    <form>
                        <div class="formItem">
                            <div class="inputItem">
                                <div class="icon">
                                    <img src="../../assets/img/login_user.png" width="16" height="20" />
                                </div>
                                <input v-model="form.account" autocomplete="account" type="text" placeholder="请输入用户名" class="formInput" @keyup.enter="goLogin" />
                            </div>
                        </div>

                        <div class="formItem">
                            <div class="inputItem">
                                <div class="icon">
                                    <img src="../../assets/img/login_password.png" width="16" height="20" />
                                </div>
                                <input v-model="form.password" autocomplete="pwd" type="password" placeholder="请输入密码" class="formInput" @keyup.enter="goLogin" />
                            </div>
                        </div>

                        <div class="formItem">
                            <el-checkbox v-model="checked">记住用户名</el-checkbox>
                        </div>

                        <div class="formItem">
                            <el-button type="primary" class="loginBtn" :loading="isRequestLoading" @click="goLogin">立即登录</el-button>
                        </div>
                    </form>

                    <div class="else">
<!--                        <div class="item">忘记密码</div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {login, getLoginBackend} from '../../api/public'
  export default {
    name: "Login",
    data () {
      return {
        imageURL: window.config.imageURL,
        form: {
          // client_id: 'admin',
          // client_secret: 'admin',
          account: '',
          password: '',
        },
        checked: false,
        isRequestLoading: false,
        backendImage: ''
      }
    },
    created() {
      if (localStorage.getItem('isShowUserName') && localStorage.getItem('isShowUserName') === 'yes') {
        this.checked = true
        this.form.account = localStorage.getItem('userName')
      }
    },
    methods: {
      getLoginBackend () {
        getLoginBackend(1).then(res => {
          if (res.code === 0) {
            this.backendImage = res.data.fileName
          }
        })
      },
      goLogin () {
        if (this.form.account === '') {
          this.$message({
            message: '请输入用户名',
            type: 'warning',
            duration: 2 * 1000
          })
          return false
        }
        if (this.form.password === '') {
          this.$message({
            message: '请输入密码',
            type: 'warning',
            duration: 2 * 1000
          })
          return false
        }
        this.isRequestLoading = true
        // const formBody = Object.keys(this.form).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.form[key]),).join('&');
        login(this.form).then(res => {
          this.isRequestLoading = false
          if (res.data.tokenInfo.tokenValue) {
            localStorage.setItem('access_token', res.data.tokenInfo.tokenValue)
            localStorage.setItem('userRole', JSON.stringify(res.data.roleMenu))
            localStorage.setItem('userName', this.form.account)
            localStorage.setItem('nickName', res.data.tokenInfo.nickName)
            localStorage.setItem('userId', res.data.tokenInfo.loginId)
            if (this.form.account == 'admin') {
              localStorage.setItem('userRole', JSON.stringify({"page":["a","b","d","f","g","h","i","j","e","c"],"power":[[["1","2","3","4","5","7","8","9","10"],["1","2","3","4","5","7","8","9","10","11"]],["1","2"],[["1","2"],["1","2","3"]],["1","2"],["1","2"],["1"],["1","2","3"],[],["1","2","3"],["1","2","3"]]}))
            }
            if (this.checked) {
              localStorage.setItem('isShowUserName', 'yes')
            } else {
              localStorage.removeItem('isShowUserName')
            }
            this.$router.push('/index')
          }
        }).catch(() => {
          this.isRequestLoading = false
        })
      },
    }
  }
</script>
